<div class="row">
  <div class="col s12">
    <h4 class="h4 chart-title chart-title--thin margin-none">
      {{ 'groups.dashboard.nps.title' | translate }}
      <gl-tooltip *ngIf="tooltipText" posBottom [text]="tooltipText"></gl-tooltip>
    </h4>
  </div>
</div>

<div class="row margin-top-quarter">
  <div class="col s12">
    <div class="range--graphic">
      <div class="range--graphic__tooltip" [ngStyle]="{ left: ((ratio + 100) / 200) * 100 + '%' }">
        <span>{{ ratio | number : '1.0-1' }}</span>
      </div>
      <div class="range--graphic__bars">
        <div>{{ 'groups.dashboard.nps.bad' | translate }}</div>
        <div>{{ 'groups.dashboard.nps.good' | translate }}</div>
        <div>{{ 'groups.dashboard.nps.awesome' | translate }}</div>
        <div>{{ 'groups.dashboard.nps.excellent' | translate }}</div>
      </div>
      <div class="range--graphic__percents">
        <div>-100</div>
        <div>0</div>
        <div>25</div>
        <div>50</div>
        <div>75</div>
        <div>100</div>
      </div>
    </div>
  </div>
</div>
